export default __webpack_public_path__ + "static/media/product-image-hover-4.63cd9ba7.jpg";